<template>
  <v-list class="NotificationsMenu__list">
    <template v-for="(item, index) in list">
      <v-divider
        v-if="index"
        :key="`divider-${item.id}-${index}`"
        class="NotificationsMenu__list-divider"
      />

      <NotificationsListItem
        :key="`item-${item.id}-${index}`"
        :title="item.title"
        :description="item.description"
        :created_at="item.created_at"
        :is_read="item.is_read"
        @action:readed="$emit('action:readed', item, $event)"
      />
    </template>

    <v-subheader
      v-if="list.length === 0"
      class="NotificationsMenu__list-no-items"
      style="height: auto; min-height: 24px;"
      v-text="'Список уведомлений пуст'"
    />
  </v-list>
</template>

<script>
import NotificationsListItem from './NotificationsListItem.vue'


export default {
  name: 'NotificationsList',
  components: {
    NotificationsListItem,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
}
</script>
